<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()){
  <app-api-table [name]="name" [endpoint]="endpoint()" [hasIndexCol]="true" [hasChartView]="false"></app-api-table>
  }
</app-tab-layout>